
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/konze",
      function () {
        return require("private-next-pages/case-study/konze.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/konze"])
      });
    }
  